import React, { useEffect } from "react";

const PolicyLayout = ({ title, children }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="relative w-full pt-10 overflow-hidden">
      {/* Main background with diagonal split like homepage */}
      <div className="absolute inset-0 bg-[#e9b320]" />
      <div
        className="absolute top-1/4 right-0 w-full h-2/3 bg-[#a41e25]"
        style={{
          clipPath: "polygon(0 30%, 100% 53%, 100% 85%, 0 60%)",
        }}
      />

      <div className="relative z-10 container mx-auto px-4 py-12 pt-36">
        <div className="flex flex-col items-center">
          <h1
            className="text-4xl md:text-8xl tracking-wider text-white mb-12 text-center [text-shadow:2px_2px_0_#4d1312,4px_4px_0_#4d1312]"
            style={{
              fontFamily: "Headlined, sans-serif",
            }}
          >
            {title.toUpperCase()}
          </h1>

          <div className="w-full max-w-5xl mx-auto mb-16">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              {/* Content */}
              <div className="p-4 md:p-8">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// SHIPPING POLICY PAGE
export const ShippingPolicy = () => {
  return (
    <PolicyLayout title="Shipping & Refund Policy">
      <div className="space-y-8">
        <div>
          <h2
            className="text-3xl md:text-4xl text-white mb-6 tracking-wider bg-[#a41e25] p-4 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
            style={{
              fontFamily: "Headlined, sans-serif",
            }}
          >
            FREE PRIME SHIPPING
          </h2>

          <p className="text-lg mb-8 text-gray-800">
            There is only 1 product for now, use this: “Zivbio Testosterone
            Booster is fulfilled by Amazon and eligible for Prime shipping. Most
            orders are delivered within 2 business days for Prime members.”
          </p>

          <div className="space-y-6">
            <h3
              className="text-2xl md:text-3xl text-white mb-4 tracking-wider bg-[#e9b320] p-3 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
              style={{
                fontFamily: "Headlined, sans-serif",
              }}
            >
              SHIPPING DETAILS
            </h3>
            <ul className="space-y-3 text-base md:text-lg text-gray-800">
              <li className="flex items-center bg-[#e9b320]/20 p-3 rounded-lg">
                <div className="min-w-10 w-10 h-10 rounded-full bg-[#a41e25] flex items-center justify-center mr-3 flex-shrink-0">
                  <span className="text-white font-bold">✓</span>
                </div>
                <span>Free Prime Shipping on all orders</span>
              </li>
              <li className="flex items-center bg-[#e9b320]/20 p-3 rounded-lg">
                <div className="min-w-10 w-10 h-10 rounded-full bg-[#a41e25] flex items-center justify-center mr-3 flex-shrink-0">
                  <span className="text-white font-bold">✓</span>
                </div>
                <span>Tracking information provided via Amazon</span>
              </li>
              <li className="flex items-center bg-[#e9b320]/20 p-3 rounded-lg">
                <div className="min-w-10 w-10 h-10 rounded-full bg-[#a41e25] flex items-center justify-center mr-3 flex-shrink-0">
                  <span className="text-white font-bold">✓</span>
                </div>
                <span>Most orders ship within 24 hours</span>
              </li>
              <li className="flex items-center bg-[#e9b320]/20 p-3 rounded-lg">
                <div className="min-w-10 w-10 h-10 rounded-full bg-[#a41e25] flex items-center justify-center mr-3 flex-shrink-0">
                  <span className="text-white font-bold">✓</span>
                </div>
                <span>Delivery typically within 2 business days</span>
              </li>
            </ul>

            <h2
              className="text-3xl md:text-4xl text-white mb-6 mt-8 tracking-wider bg-[#a41e25] p-4 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
              style={{
                fontFamily: "Headlined, sans-serif",
              }}
            >
              SATISFACTION GUARANTEED
            </h2>

            <div className="space-y-4 text-lg">
              <div className="flex items-center bg-gray-100 p-4 rounded-lg">
                <div className="min-w-12 w-12 h-12 flex-shrink-0 bg-[#a41e25] rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl text-white">1</span>
                </div>
                <p className="text-gray-800">
                  We prioritize your satisfaction. If you are not completely
                  satisfied with your purchase or feel that the product did not
                  meet your expectations, you can request a full refund within
                  15 days of receiving your order. Simply fill out the form on
                  our{" "}
                  <a
                    href="/satisfaction-guaranteed"
                    target="_blank"
                    rel="noreferrer"
                    className="text-red-600  hover:underline transition-colors duration-300 hover:scale-105 hover:font-semibold"
                  >
                    Satisfaction Guaranteed
                  </a>{" "}
                  page
                </p>
              </div>

              <div className="flex items-center bg-gray-100 p-4 rounded-lg">
                <div className="min-w-12 w-12 h-12 flex-shrink-0 bg-[#a41e25] rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl text-white">2</span>
                </div>
                <p className="text-gray-800">
                  Refunds are generally processed within 24 hours of receiving
                  your request. Thank you for shopping with us!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PolicyLayout>
  );
};

// PRIVACY POLICY PAGE
export const PrivacyPolicy = () => {
  return (
    <PolicyLayout title="Privacy Policy">
      <div className="space-y-8">
        <div>
          <h2
            className="text-3xl md:text-4xl text-white mb-6 tracking-wider bg-[#a41e25] p-4 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
            style={{
              fontFamily: "Headlined, sans-serif",
            }}
          >
            LAST UPDATED: FEBRUARY 18, 2025
          </h2>

          <p className="text-lg mb-8 text-gray-800 bg-[#e9b320]/20 p-4 rounded-lg">
            This Privacy Policy describes how ZivBio Testosterone Booster (the
            "Site", "we", "us", or "our") collects, uses, and discloses your
            personal information when you visit, use our services, or make a
            purchase or otherwise communicate with us regarding the Site
            (collectively, the "Services").
          </p>

          <h3
            className="text-2xl md:text-3xl text-white mb-4 tracking-wider bg-[#e9b320] p-3 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
            style={{
              fontFamily: "Headlined, sans-serif",
            }}
          >
            INFORMATION WE COLLECT AND SHARE
          </h3>

          {/* Mobile version - stacked table */}
          <div className="block md:hidden mb-8">
            <div className="bg-[#a41e25] rounded-t-lg p-4">
              <h4 className="text-white font-bold text-lg">Category</h4>
            </div>
            <div className="bg-[#e9b320]/20 p-4 rounded-b-lg mb-4">
              <ul className="list-none space-y-3">
                {[
                  "Identifiers such as basic contact details and certain order and account information",
                  "Personal information categories listed in the California Customer Records statute",
                  "Commercial information such as order information and customer support information",
                  "Internet or other similar network activity, such as Usage Data",
                  "Geolocation data such as IP address locations",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <div className="min-w-6 w-6 h-6 rounded-full bg-[#a41e25] flex items-center justify-center mr-2 mt-1 flex-shrink-0">
                      <span className="text-white text-xs">✓</span>
                    </div>
                    <span className="text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-[#a41e25] rounded-t-lg p-4">
              <h4 className="text-white font-bold text-lg">
                Categories of Recipients
              </h4>
            </div>
            <div className="bg-[#e9b320]/20 p-4 rounded-b-lg">
              <ul className="list-none space-y-3">
                {[
                  "Vendors and third parties who perform services on our behalf (such as payment processors, fulfillment partners)",
                  "Business and marketing partners",
                  "Affiliates",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <div className="min-w-6 w-6 h-6 rounded-full bg-[#a41e25] flex items-center justify-center mr-2 mt-1 flex-shrink-0">
                      <span className="text-white text-xs">✓</span>
                    </div>
                    <span className="text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Desktop version - table */}
          <div className="hidden md:block overflow-hidden rounded-lg border border-gray-200 mb-8">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-[#a41e25]">
                <tr>
                  <th className="px-6 py-4 text-left text-white font-bold">
                    Category
                  </th>
                  <th className="px-6 py-4 text-left text-white font-bold">
                    Categories of Recipients
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr className="bg-[#e9b320]/20">
                  <td className="px-6 py-4">
                    <ul className="list-none ml-4 space-y-2">
                      {[
                        "Identifiers such as basic contact details and certain order and account information",
                        "Personal information categories listed in the California Customer Records statute",
                        "Commercial information such as order information and customer support information",
                        "Internet or other similar network activity, such as Usage Data",
                        "Geolocation data such as IP address locations",
                      ].map((item, index) => (
                        <li key={index} className="flex items-center">
                          <div className="min-w-6 w-6 h-6 rounded-full bg-[#a41e25] flex items-center justify-center mr-2 flex-shrink-0">
                            <span className="text-white text-xs">✓</span>
                          </div>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td className="px-6 py-4">
                    <ul className="list-none ml-4 space-y-2">
                      {[
                        "Vendors and third parties who perform services on our behalf (such as payment processors, fulfillment partners)",
                        "Business and marketing partners",
                        "Affiliates",
                      ].map((item, index) => (
                        <li key={index} className="flex items-center">
                          <div className="min-w-6 w-6 h-6 rounded-full bg-[#a41e25] flex items-center justify-center mr-2 flex-shrink-0">
                            <span className="text-white text-xs">✓</span>
                          </div>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Your Rights and Contact Us section - stacks on mobile */}
          <div className="flex flex-col md:flex-row md:gap-6 mb-8">
            <div className="w-full md:w-1/2 mb-6 md:mb-0">
              <div className="bg-[#a41e25] text-white p-4 rounded-t-lg">
                <h3 className="font-bold text-xl [text-shadow:1px_1px_0_#4d1312]">
                  YOUR RIGHTS
                </h3>
              </div>
              <div className="bg-[#e9b320]/20 p-4 rounded-b-lg">
                <ul className="space-y-2">
                  {[
                    "Right to Access Personal Information",
                    "Right to Delete Personal Information",
                    "Right to Correct Inaccurate Information",
                    "Right of Portability",
                  ].map((item, index) => (
                    <li key={index} className="flex items-center">
                      <div className="min-w-6 w-6 h-6 rounded-full bg-[#a41e25] flex items-center justify-center mr-2 flex-shrink-0">
                        <span className="text-white text-xs">✓</span>
                      </div>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-[#e9b320] text-white p-4 rounded-t-lg">
                <h3 className="font-bold text-xl [text-shadow:1px_1px_0_#4d1312]">
                  CONTACT US
                </h3>
              </div>
              <div className="bg-gray-100 p-4 rounded-b-lg flex items-center">
                <p>
                  If you have any questions about our privacy practices or would
                  like to exercise any of your rights, please contact us through
                  our Contact form or email us at{" "}
                  <span className="font-bold text-[#a41e25]">
                    <a
                      href="mailto:support@zivbiolabs.com"
                      className="hover:text-primary-yellow transition-colors"
                    >
                      support@zivbiolabs.com
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PolicyLayout>
  );
};

// TERMS OF SERVICE PAGE
export const Terms = () => {
  return (
    <PolicyLayout title="Terms of Service">
      <div className="space-y-8">
        <div>
          <h2
            className="text-4xl  text-white mb-6 tracking-wider bg-[#a41e25] p-4 rounded-lg [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
            style={{
              fontFamily: "Headlined, sans-serif",
            }}
          >
            EFFECTIVE DATE: FEBRUARY 18, 2025
          </h2>

          <p className="text-lg mb-8 text-gray-800 bg-[#e9b320]/20 p-4 rounded-lg">
            Welcome to Website. By accessing or using this site, you agree to
            comply with and be bound by the following terms and conditions.
          </p>

          <div className="relative overflow-hidden bg-[#e9b320] p-6 rounded-lg mb-6">
            <div
              className="absolute top-0 right-0 w-1/4 h-full bg-[#a41e25]"
              style={{
                clipPath: "polygon(100% 0, 0 0, 100% 100%)",
              }}
            />
            <h3
              className="relative z-10 text-3xl  text-white mb-2 tracking-wider [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
              style={{
                fontFamily: "Headlined, sans-serif",
              }}
            >
              1. ACCEPTANCE OF TERMS
            </h3>
          </div>

          <div className="flex items-center bg-gray-100 p-4 rounded-lg mb-6">
            <div className="w-10 h-10 flex-shrink-0 bg-[#a41e25] rounded-full flex items-center justify-center mr-4">
              <span className="text-xl text-white">1</span>
            </div>
            <p className="text-gray-800">
              By using the website, you agree to these Terms and Conditions and
              our Privacy Policy. We may modify these terms at any time, and
              your continued use of the site after any modifications signifies
              your acceptance of the updated terms.
            </p>
          </div>

          <div className="relative overflow-hidden bg-[#e9b320] p-6 rounded-lg mb-6">
            <div
              className="absolute top-0 right-0 w-1/4 h-full bg-[#a41e25]"
              style={{
                clipPath: "polygon(100% 0, 0 0, 100% 100%)",
              }}
            />
            <h3
              className="relative z-10 text-3xl  text-white mb-2 tracking-wider [text-shadow:1px_1px_0_#4d1312,2px_2px_0_#4d1312]"
              style={{
                fontFamily: "Headlined, sans-serif",
              }}
            >
              2. USER OBLIGATIONS
            </h3>
          </div>

          <div className="flex items-center bg-gray-100 p-4 rounded-lg">
            <div className="w-10 h-10 flex-shrink-0 bg-[#a41e25] rounded-full flex items-center justify-center mr-4">
              <span className="text-xl text-white">2</span>
            </div>
            <p className="text-gray-800">
              When using this Website, you agree not to violate any applicable
              laws or regulations, infringe on intellectual property rights, or
              use our site for any unauthorized or illegal purpose.
            </p>
          </div>
        </div>
      </div>
    </PolicyLayout>
  );
};

const policies = {
  PrivacyPolicy,
  Terms,
  ShippingPolicy,
};

export default policies;
